<template>
  <ul class="list useGuideContainer">
    <li v-for="(item, key) in list" :key="key">
      <img v-lazy="item.img" alt="">
    </li>
    <li class="btn">
      <a href="https://h5.haoyishu.org/article/6774?appVersion=6.0.0">
        <img src="https://img-a.haoyishu.com/images/useguide/app_06.png" alt="">
      </a>
    </li>
  </ul>
</template>

<script setup>
import { ref } from 'vue'
const list = ref([
  {
    img: 'https://img-a.haoyishu.com/images/useguide/app_01.png'
  },
  {
    img: 'https://img-a.haoyishu.com/images/useguide/app_02.png'
  },
  {
    img: 'https://img-a.haoyishu.com/images/useguide/app_03.png'
  },
  {
    img: 'https://img-a.haoyishu.com/images/useguide/app_04.png'
  },
  {
    img: 'https://img-a.haoyishu.com/images/useguide/app_05.png'
  }
])

</script>

<style lang="scss" scoped>
.useGuideContainer {
  width: 750px;
  margin: 0 auto;
  li {
    width: 100%;
    overflow: hidden;
    img {
      width: 100%;
      display: block;
    }
  }
}
</style>
